import { render, staticRenderFns } from "./parkschool.vue?vue&type=template&id=34eff8de&scoped=true&"
import script from "./parkschool.vue?vue&type=script&lang=js&"
export * from "./parkschool.vue?vue&type=script&lang=js&"
import style0 from "./parkschool.vue?vue&type=style&index=0&id=34eff8de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eff8de",
  null
  
)

export default component.exports